function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(0 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.7703081232492996s",
  repeatCount: "indefinite"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(30 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.7002801120448179s",
  repeatCount: "indefinite"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(60 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.6302521008403361s",
  repeatCount: "indefinite"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(90 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.5602240896358543s",
  repeatCount: "indefinite"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(120 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.49019607843137253s",
  repeatCount: "indefinite"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(150 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.4201680672268907s",
  repeatCount: "indefinite"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(180 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.35014005602240894s",
  repeatCount: "indefinite"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(210 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.2801120448179272s",
  repeatCount: "indefinite"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(240 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.21008403361344535s",
  repeatCount: "indefinite"
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(270 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.1400560224089636s",
  repeatCount: "indefinite"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(300 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "-0.0700280112044818s",
  repeatCount: "indefinite"
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(330 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#5e6fa3"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8403361344537814s",
  begin: "0s",
  repeatCount: "indefinite"
})));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "118px",
    height: "118px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Spinner.ca66be0f.svg";
export { ForwardRef as ReactComponent };